module.exports = __webpack_public_path__ + "static/future-of-work-the-office-isnt-dead-and-never-will-be-ca6ceaa3a8b4656f3a033bbbb4bc742c.png";